// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";
import Helmet            from "preact-helmet";
import { ScrollTop }     from "shared-components";
import { getCmsMeta }    from "../../helpers/getMetaData";

import Wrapper from "../../components/Wrapper";

@connect(
  state => ({
    page: state.cmsPage.data
  })
)
export default class CmsPage extends PureComponent {
  render({ page }: Props) {
    const meta = getCmsMeta(page);

    return (
      <div
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <Wrapper modifiers="medium">
          <article class={classNames(styles.body, "typography")}>
            <h1>
              {page.content_heading || page.title}
            </h1>

            <div
                dangerouslySetInnerHTML={{ __html: page.html }}
                class={classNames(
                  "text_row__large",
                  styles.content
                )}
            />
          </article>

          <ScrollTop />

          <Helmet
              title={meta.title}
              meta={meta.data}
          />
        </Wrapper>
      </div>
    );
  }
}
